var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-box"},[_c('div',{staticClass:"slot"},[_vm._t("default")],2),_c('div',{staticClass:"tooltip card"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }